export const REDUCER_NAME = {
    MODERATOR_CONTROLLER: 'features/moderator-controller',
    CHAT: 'features/chat',
    PARTICIPANTS_PANE: 'features/participants-pane',
    SECURITY: 'features/security',
    LOBBY: 'features/lobby',
    AV_MODERATION: 'features/av-moderation',
    DIALOG: 'features/base/dialog',
    BASE_PARTICIPANTS: 'features/base/participants',
    FILMSTRIP: 'features/filmstrip',
    LIVE_CAPTION: 'features/live-caption',
    USER: 'features/user',
    SETTINGS: 'features/base/settings',
    TRACKS: 'features/base/tracks',
    BASE_CONFIG: 'features/base/config'
};
export const MODERATOR_CONTROLLER_KEY = "features/moderator-controller";
export const MODERATOR_CONTROLLER_OPEN = "MODERATOR_CONTROLLER_OPEN";
export const MODERATOR_CONTROLLER_CLOSE = "MODERATOR_CONTROLLER_CLOSE";
